module.exports = __webpack_public_path__ + "images/efd44ba5d5d61410161c4d7dc8a65d0b.jpg";